import { ChangeEvent, useEffect } from "react";
import { getEmployeeList } from "src/apis/employeeApi";
import { CodeForm } from "src/components/common/form/CodeForm";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { EQM2070_R01HeaderDto } from "./Dto_EQM2070_R01";
import { useEQM2070_R01Store } from "./Store_EQM2070_R01";

interface Props {
	defaultEQM2070_R01HeaderRow: EQM2070_R01HeaderDto;
}

export const Info_EQM2070_R01 = ({ defaultEQM2070_R01HeaderRow }: Props) => {
	const {
		editEQM2070_R01,
		setEditEQM2070_R01,
		selectedEQM2070_R01,
	} = useEQM2070_R01Store();
	const { cycleList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const judgeEmpnoFocusId = "judgeEmpnoInput_EQM2070_R01";
	const editData = editEQM2070_R01 ?? defaultEQM2070_R01HeaderRow;

	useEffect(() => {
		if (selectedEQM2070_R01) {
			setEditEQM2070_R01({ ...defaultEQM2070_R01HeaderRow, ...selectedEQM2070_R01 });
		} else {
			setEditEQM2070_R01({ ...defaultEQM2070_R01HeaderRow });
		}
	}, [selectedEQM2070_R01, defaultEQM2070_R01HeaderRow, setEditEQM2070_R01]);

	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;
		setEditEQM2070_R01({
			...editData,
			[name]: value,
		});
	};

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "judgeEmpno",
			category: "담당자",
			focusId: judgeEmpnoFocusId,
			responseMapping: {
				empNo: "judgeEmpno",
				empNm: "judgeEmpNm",
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList("all");
				return employeeResponse.data.data.find((value) => value.empNo === code);
			},
			extraFilter: () => ({
				judgeEmpno: editData.judgeEmpno || "",
				judgeEmpNm: editData.judgeEmpNm || "",
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData,
		setEditData: setEditEQM2070_R01,
		defaultData: defaultEQM2070_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "EQM2070_R01",
	});

	const inputWrapperStyle = {
		wrapperStyle: "w-[250px] min-w-[250px] mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		inputStyle: "w-[150px] min-w-[150px]",
	};

	const codeWrapperStyle = {
		wrapperStyle: "w-[515px] min-w-[515px] shrink-0 mr-[10px] mb-[5px]",
		titleStyle: "w-[100px] min-w-[100px]",
		codeInputStyle: "w-[150px] min-w-[150px]",
		custNmInputStyle: "w-[255px] min-w-[255px]",
	};

	return (
		<div className="flex items-center flex-wrap px-[12px] pt-[8px] pb-[4px]">
			<DropDownForm<SysCodeDto>
				title="점검주기"
				value={editData.inspectCycle}
				data={cycleList}
				editable={false}
				name="inspectCycle"
				initLabelLess={true}
				onChange={handleChange}
				wrapperOption={inputWrapperStyle}
			/>
			<CodeForm
				label="담당자"
				value={editData.judgeEmpno || ""}
				custNmValue={editData.judgeEmpNm || ""}
				editable={true}
				handleFoucsId={judgeEmpnoFocusId}
				name="judgeEmpno"
				wrapperOption={codeWrapperStyle}
				handleChange={getFieldHandlers("judgeEmpno").onChange}
				onDoubleClick={getFieldHandlers("judgeEmpno").onDoubleClick}
				onKeyDown={getFieldHandlers("judgeEmpno").onEnterKeyDown}
			/>
			<InputForm
				title="조치내용"
				value={editData.remark || ""}
				name="remark"
				maxLength={1000}
				editable={true}
				onChange={handleChange}
				wrapperOption={{
					wrapperStyle: "flex-1 min-w-[300px] mr-[10px] mb-[5px]",
					titleStyle: "w-[100px] min-w-[100px]",
					inputStyle: "flex-1 min-w-0",
				}}
			/>
		</div>
	);
};
